module.exports = __webpack_public_path__ + "static/foresee-87c992db29aa14a99a5b7c899ebbb4e4.jpg";